export type FooString = string;
